import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SetupBillsView } from './setupbillsview.jsx';
import { MessageType, MessageClass, MsgForFailedData, NoClientFoundSetupBill } from '../../common/constants';
import { getVendorService, getCountryStateService, CreateVendorPaymentInstructionForWireService, getWireInstructions, getPayTerms } from '../../services/billpayservice/billpayservices';
import { validateABA, validateABACancellationToken, getEligibleFromAccount } from "../../services/externalaccountservice/externalAccountService";
import { generatePaymentInstructionRequest, isVendorNameExist } from './setupBillUtility.js';
import { ViewWireInstructions } from '../../actions/vendorsAction';
import * as cloneDeep from 'lodash/cloneDeep';
import { wireInstructionFormAnimation } from '../../common/animation.js';
import { Spinner } from 'reactstrap';
import { message } from 'antd';

class SetupBills extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.handleFormChanges = this.handleFormChanges.bind(this);
        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.typesOfVendorToggle = this.typesOfVendorToggle.bind(this);
        this.typesOfVendorChange = this.typesOfVendorChange.bind(this);
        this.toggleAutoPaySetup = this.toggleAutoPaySetup.bind(this);
        this.checkPhoneNoFormat = this.checkPhoneNoFormat.bind(this);
        this.checkEmailFormat = this.checkEmailFormat.bind(this);
        this.vendorToggle = this.vendorToggle.bind(this);
        this.vendorChange = this.vendorChange.bind(this);
        this.combinePaymentsToggle = this.combinePaymentsToggle.bind(this);
        this.combinePaymentsChange = this.combinePaymentsChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.disableNextBtn = this.disableNextBtn.bind(this);
        this.isSaveDisabled = this.isSaveDisabled.bind(this);
        this.clearData = this.clearData.bind(this);
        this.getVendorList = this.getVendorList.bind(this);
        this.accountOwnershipToggle = this.accountOwnershipToggle.bind(this);
        this.accountOwnershipChange = this.accountOwnershipChange.bind(this);
        this.getBankName = this.getBankName.bind(this);
        this.handleNewStandingInstructionChange = this.handleNewStandingInstructionChange.bind(this);
        this.handleVendorNameChange = this.handleVendorNameChange.bind(this);
        this.handleVendorNameOnBlur = this.handleVendorNameOnBlur.bind(this);
        this.getCountryStateList = this.getCountryStateList.bind(this);
        this.addressCountryToggle = this.addressCountryToggle.bind(this);
        this.stateProvinceChange = this.stateProvinceChange.bind(this);
        this.addressCountryChange = this.addressCountryChange.bind(this);
        this.stateProvinceToggle = this.stateProvinceToggle.bind(this);
        this.typesOfPartyToggle = this.typesOfPartyToggle.bind(this);
        this.typesOfPartyChange = this.typesOfPartyChange.bind(this);

        this.prepopulateData = this.prepopulateData.bind(this);
        this.backFromVendors = this.backFromVendors.bind(this);
        this.fromAcctToggle = this.fromAcctToggle.bind(this);
        this.payTermToggle = this.payTermToggle.bind(this);
        this.handleFromAcctChange = this.handleFromAcctChange.bind(this);
        this.handlePayTermChange = this.handlePayTermChange.bind(this);

        this.requesterId = "";
        if (this.props.portalid !== null && this.props.portalid !== undefined) {
            this.requesterId = this.props.portalid;
        }

        this.authToken = "";
        if (this.props.token !== null && this.props.token !== undefined) {
            this.authToken = this.props.token;
        }

        this.contextjson = null;
        if (this.props.contextjson !== null && this.props.contextjson !== undefined) {
            this.contextjson = this.props.contextjson;
        }

        this.profilejson = null;
        if (this.props.profilejson !== null && this.props.profilejson !== undefined) {
            this.profilejson = this.props.profilejson;
        }

        this.state = {
            activeTab: '1',
            billInformation: {
                vendorbasics: {
                    vendorname: "",
                    vendortype: "",
                    vendortypevalue: "",
                    primarycontactemail: "",
                    accountnumberwithvendor: "",
                    vendorZipcode: ""
                },
                vendoraddress: {
                    country: "",
                    addressline1: "",
                    addressline2: "",
                    addressline3: "",
                    addressline4: "",
                    city: "",
                    stateprovince: "",
                    zippostalcode: "",
                },
                vendorbanklocation: "",
                vendorpaymenttype: "WIRE",
                vendorparentid: '',
                vendorpayterm: '',
                vendorpaytermrefcode: '',
                autopaysetup: false,
                paymentinfo: {
                    paytoname: "",
                    paymentnotificationemail: "",
                    phone: "",
                    fax: "",
                    accountOwnership: "",
                    accountNickname: "",
                    bankName: "",
                    accountNumber: "",
                    routingNumber: "",
                    wirePurpose: "",
                    line1: "",
                    line2: "",
                    line3: "",
                    line4: "",
                    newStandingInstruction: false,
                    standingInstructionNickname: "",
                    furtherCreditAccountNumber: "",
                    furtherCreditName: "",
                    furtherCreditAddressLine1: "",
                    furtherCreditAddressLine2: "",
                    furtherCreditAddressLine3: "",
                    beneficiaryDetailsAccountNumber: "",
                    beneficiaryDetailsVendorname: "",
                    beneficiaryDetailsAddressline1: "",
                    beneficiaryDetailsAddressline2: "",
                    beneficiaryDetailsAddressline3: "",
                    furtherCredit2AccountNumber: "",
                    furtherCredit2Name: "",
                    furtherCredit2AddressLine1: "",
                    furtherCredit2AddressLine2: "",
                    furtherCredit2AddressLine3: "",
                    country: 'US',
                    isThirdParty: false,
                    partydisplayvalue: ''
                },
                contacts: {
                    firstname: "",
                    lastname: ""
                },
                vendordescription: "",
                additionalInformation: {
                    taxid: "",
                    vendor: "",
                    vendorsince: "",
                    leadtimedays: "",
                    combinepayments: "",
                    paymentterms: "",
                    companyname: ""

                }
            },
            validationBillInformation: {
                vendorbasics: {
                    vendorname: false,
                    vendortype: false,
                    primarycontactemail: true,
                },
                vendoraddress: {
                    country: false
                },
                vendorbanklocation: false,
                paymentinfo: {
                    paymentnotificationemail: true,
                    phone: true,
                    fax: true,
                    routingNumber: false,
                    wirePurpose: false,
                },
            },
            isTypesOfVendorOpen: false,
            isTypesOfPartyOpen: false,
            isFromAcctOpen: false,
            isPayTermOpen: false,
            typesOfVendors: [{'name': "Business", 'value': "1"}, {'name': "Individual", 'value': "2"}],
            typesOfParties: [{'name': "1st Party", 'value': false}, {'name': "3rd Party", 'value': true}],
            isVendorOpen: false,
            listOfVendors: ["Vendor1", "Vendor2"],
            isCombinePaymentsOpen: false,
            combinePaymentsTypes: ["Yes", "No"],
            isPaymentTermsOpen: false,
            paymentTermsTypes: ["Term Type 1", "Term Type 2", "Term Type 3"],
            isAddressCountryOpen: false,
            isStateProvinceOpen: false,
            errorMsg: "",
            messages: {},
            vendorList: [],
            payTermsList: [],
            isAccountOwnershipOpen: false,
            accountOwnershipTypes: [{ "value": "self", "description": "My Account" }, { "value": "other", "description": "Someone Else's Account" }],
            vendorOptions: [],
            isLargeVendor: false,
            isloading: true,
            requestFailed: false,
            stateList: [{ "statecode": "AK", "statename": "ALASKA" }, { "statecode": "AL", "statename": "ALABAMA" }, { "statecode": "AR", "statename": "ARKANSAS" }, { "statecode": "AS", "statename": "AMERICAN SAMOA" }, { "statecode": "AZ", "statename": "ARIZONA" }, { "statecode": "CA", "statename": "CALIFORNIA" }, { "statecode": "CO", "statename": "COLORADO" }, { "statecode": "CT", "statename": "CONNECTICUT" }, { "statecode": "CZ", "statename": "CANAL ZONE" }, { "statecode": "DC", "statename": "DISTRICT OF COLUMBIA" }, { "statecode": "DE", "statename": "DELAWARE" }, { "statecode": "FL", "statename": "FLORIDA" }, { "statecode": "FM", "statename": "FEDERATED STATES OF MICRONESIA" }, { "statecode": "GA", "statename": "GEORGIA" }, { "statecode": "GU", "statename": "GUAM" }, { "statecode": "HI", "statename": "HAWAII" }, { "statecode": "IA", "statename": "IOWA" }, { "statecode": "ID", "statename": "IDAHO" }, { "statecode": "IL", "statename": "ILLINOIS" }, { "statecode": "IN", "statename": "INDIANA" }, { "statecode": "KS", "statename": "KANSAS" }, { "statecode": "KY", "statename": "KENTUCKY" }, { "statecode": "LA", "statename": "LOUISIANA" }, { "statecode": "MA", "statename": "MASSACHUSETTS" }, { "statecode": "MD", "statename": "MARYLAND" }, { "statecode": "ME", "statename": "MAINE" }, { "statecode": "MH", "statename": "MARSHALL ISLANDS" }, { "statecode": "MI", "statename": "MICHIGAN" }, { "statecode": "MN", "statename": "MINNESOTA" }, { "statecode": "MO", "statename": "MISSOURI" }, { "statecode": "MS", "statename": "MISSISSIPPI" }, { "statecode": "MT", "statename": "MONTANA" }, { "statecode": "NC", "statename": "NORTH CAROLINA" }, { "statecode": "ND", "statename": "NORTH DAKOTA" }, { "statecode": "NE", "statename": "NEBRASKA" }, { "statecode": "NH", "statename": "NEW HAMPSHIRE" }, { "statecode": "NJ", "statename": "NEW JERSEY" }, { "statecode": "NM", "statename": "NEW MEXICO" }, { "statecode": "NV", "statename": "NEVADA" }, { "statecode": "NY", "statename": "NEW YORK" }, { "statecode": "OH", "statename": "OHIO" }, { "statecode": "OK", "statename": "OKLAHOMA" }, { "statecode": "OR", "statename": "OREGON" }, { "statecode": "PA", "statename": "PENNSYLVANIA" }, { "statecode": "PR", "statename": "PUERTO RICO" }, { "statecode": "PW", "statename": "PALAU" }, { "statecode": "RI", "statename": "RHODE ISLAND" }, { "statecode": "SC", "statename": "SOUTH CAROLINA" }, { "statecode": "SD", "statename": "SOUTH DAKOTA" }, { "statecode": "TN", "statename": "TENNESSEE" }, { "statecode": "TX", "statename": "TEXAS" }, { "statecode": "UM", "statename": "U.S. MINOR OUTLYING ISLANDS" }, { "statecode": "UT", "statename": "UTAH" }, { "statecode": "VA", "statename": "VIRGINIA" }, { "statecode": "VI", "statename": "VIRGIN ISLANDS" }, { "statecode": "VT", "statename": "VERMONT" }, { "statecode": "WA", "statename": "WASHINGTON" }, { "statecode": "WI", "statename": "WISCONSIN" }, { "statecode": "WV", "statename": "WEST VIRGINIA" }, { "statecode": "WY", "statename": "WYOMING" }],
            countryList: [{ "countrycode": "AD", "countryname": "Andorra" }, { "countrycode": "AE", "countryname": "United Arab Emirates" }, { "countrycode": "AF", "countryname": "Afghanistan" }, { "countrycode": "AG", "countryname": "Antigua and Barbuda" }, { "countrycode": "AI", "countryname": "Anguilla" }, { "countrycode": "AL", "countryname": "Albania" }, { "countrycode": "AM", "countryname": "Armenia" }, { "countrycode": "AO", "countryname": "Angola" }, { "countrycode": "AQ", "countryname": "Antarctica" }, { "countrycode": "AR", "countryname": "Argentina" }, { "countrycode": "AS", "countryname": "American Samoa" }, { "countrycode": "AT", "countryname": "Austria" }, { "countrycode": "AU", "countryname": "Australia" }, { "countrycode": "AW", "countryname": "Aruba" }, { "countrycode": "AX", "countryname": "Aland Islands" }, { "countrycode": "AZ", "countryname": "Azerbaijan" }, { "countrycode": "BA", "countryname": "Bosnia and Herzegovina" }, { "countrycode": "BB", "countryname": "Barbados" }, { "countrycode": "BD", "countryname": "Bangladesh" }, { "countrycode": "BE", "countryname": "Belgium" }, { "countrycode": "BF", "countryname": "Burkina Faso" }, { "countrycode": "BG", "countryname": "Bulgaria" }, { "countrycode": "BH", "countryname": "Bahrain" }, { "countrycode": "BI", "countryname": "Burundi" }, { "countrycode": "BJ", "countryname": "Benin" }, { "countrycode": "BL", "countryname": "Saint Barthelemy" }, { "countrycode": "BM", "countryname": "Bermuda" }, { "countrycode": "BN", "countryname": "Brunei Darussalam" }, { "countrycode": "BO", "countryname": "Bolivia, Plurinational State of" }, { "countrycode": "BQ", "countryname": "Bonaire, Saint Eustatius and Saba" }, { "countrycode": "BR", "countryname": "Brazil" }, { "countrycode": "BS", "countryname": "Bahamas" }, { "countrycode": "BT", "countryname": "Bhutan" }, { "countrycode": "BV", "countryname": "Bouvet Island" }, { "countrycode": "BW", "countryname": "Botswana" }, { "countrycode": "BY", "countryname": "Belarus" }, { "countrycode": "BZ", "countryname": "Belize" }, { "countrycode": "CA", "countryname": "Canada" }, { "countrycode": "CC", "countryname": "Cocos (Keeling) Islands" }, { "countrycode": "CD", "countryname": "Congo, the Democratic Republic of the" }, { "countrycode": "CF", "countryname": "Central African Republic" }, { "countrycode": "CG", "countryname": "Congo" }, { "countrycode": "CH", "countryname": "Switzerland" }, { "countrycode": "CI", "countryname": "Cote d'Ivoire" }, { "countrycode": "CK", "countryname": "Cook Islands" }, { "countrycode": "CL", "countryname": "Chile" }, { "countrycode": "CM", "countryname": "Cameroon" }, { "countrycode": "CN", "countryname": "China" }, { "countrycode": "CO", "countryname": "Colombia" }, { "countrycode": "CR", "countryname": "Costa Rica" }, { "countrycode": "CU", "countryname": "Cuba" }, { "countrycode": "CV", "countryname": "Cape Verde" }, { "countrycode": "CW", "countryname": "Curacao" }, { "countrycode": "CX", "countryname": "Christmas Island" }, { "countrycode": "CY", "countryname": "Cyprus" }, { "countrycode": "CZ", "countryname": "Czech Republic" }, { "countrycode": "DE", "countryname": "Germany" }, { "countrycode": "DJ", "countryname": "Djibouti" }, { "countrycode": "DK", "countryname": "Denmark" }, { "countrycode": "DM", "countryname": "Dominica" }, { "countrycode": "DO", "countryname": "Dominican Republic" }, { "countrycode": "DZ", "countryname": "Algeria" }, { "countrycode": "EC", "countryname": "Ecuador" }, { "countrycode": "EE", "countryname": "Estonia" }, { "countrycode": "EG", "countryname": "Egypt" }, { "countrycode": "EH", "countryname": "Western Sahara" }, { "countrycode": "ER", "countryname": "Eritrea" }, { "countrycode": "ES", "countryname": "Spain" }, { "countrycode": "ET", "countryname": "Ethiopia" }, { "countrycode": "FI", "countryname": "Finland" }, { "countrycode": "FJ", "countryname": "Fiji" }, { "countrycode": "FK", "countryname": "Falkland Islands (Malvinas)" }, { "countrycode": "FM", "countryname": "Micronesia, Federated States of" }, { "countrycode": "FO", "countryname": "Faroe Islands" }, { "countrycode": "FR", "countryname": "France" }, { "countrycode": "GA", "countryname": "Gabon" }, { "countrycode": "GB", "countryname": "United Kingdom" }, { "countrycode": "GD", "countryname": "Grenada" }, { "countrycode": "GE", "countryname": "Georgia" }, { "countrycode": "GF", "countryname": "French Guiana" }, { "countrycode": "GG", "countryname": "Guernsey" }, { "countrycode": "GH", "countryname": "Ghana" }, { "countrycode": "GI", "countryname": "Gibraltar" }, { "countrycode": "GL", "countryname": "Greenland" }, { "countrycode": "GM", "countryname": "Gambia" }, { "countrycode": "GN", "countryname": "Guinea" }, { "countrycode": "GP", "countryname": "Guadeloupe" }, { "countrycode": "GQ", "countryname": "Equatorial Guinea" }, { "countrycode": "GR", "countryname": "Greece" }, { "countrycode": "GS", "countryname": "South Georgia and the South Sandwich Islands" }, { "countrycode": "GT", "countryname": "Guatemala" }, { "countrycode": "GU", "countryname": "Guam" }, { "countrycode": "GW", "countryname": "Guinea-Bissau" }, { "countrycode": "GY", "countryname": "Guyana" }, { "countrycode": "HK", "countryname": "Hong Kong" }, { "countrycode": "HM", "countryname": "Heard Island and McDonald Islands" }, { "countrycode": "HN", "countryname": "Honduras" }, { "countrycode": "HR", "countryname": "Croatia" }, { "countrycode": "HT", "countryname": "Haiti" }, { "countrycode": "HU", "countryname": "Hungary" }, { "countrycode": "ID", "countryname": "Indonesia" }, { "countrycode": "IE", "countryname": "Ireland" }, { "countrycode": "IL", "countryname": "Israel" }, { "countrycode": "IM", "countryname": "Isle of Man" }, { "countrycode": "IN", "countryname": "India" }, { "countrycode": "IO", "countryname": "British Indian Ocean Territory" }, { "countrycode": "IQ", "countryname": "Iraq" }, { "countrycode": "IR", "countryname": "Iran, Islamic Republic of" }, { "countrycode": "IS", "countryname": "Iceland" }, { "countrycode": "IT", "countryname": "Italy" }, { "countrycode": "JE", "countryname": "Jersey" }, { "countrycode": "JM", "countryname": "Jamaica" }, { "countrycode": "JO", "countryname": "Jordan" }, { "countrycode": "JP", "countryname": "Japan" }, { "countrycode": "KE", "countryname": "Kenya" }, { "countrycode": "KG", "countryname": "Kyrgyzstan" }, { "countrycode": "KH", "countryname": "Cambodia" }, { "countrycode": "KI", "countryname": "Kiribati" }, { "countrycode": "KM", "countryname": "Comoros" }, { "countrycode": "KN", "countryname": "Saint Kitts and Nevis" }, { "countrycode": "KP", "countryname": "Korea, Democratic People's Republic of" }, { "countrycode": "KR", "countryname": "Korea, Republic of" }, { "countrycode": "KW", "countryname": "Kuwait" }, { "countrycode": "KY", "countryname": "Cayman Islands" }, { "countrycode": "KZ", "countryname": "Kazakhstan" }, { "countrycode": "LA", "countryname": "Lao People's Democratic Republic" }, { "countrycode": "LB", "countryname": "Lebanon" }, { "countrycode": "LC", "countryname": "Saint Lucia" }, { "countrycode": "LI", "countryname": "Liechtenstein" }, { "countrycode": "LK", "countryname": "Sri Lanka" }, { "countrycode": "LR", "countryname": "Liberia" }, { "countrycode": "LS", "countryname": "Lesotho" }, { "countrycode": "LT", "countryname": "Lithuania" }, { "countrycode": "LU", "countryname": "Luxembourg" }, { "countrycode": "LV", "countryname": "Latvia" }, { "countrycode": "LY", "countryname": "Libyan Arab Jamahiriya" }, { "countrycode": "MA", "countryname": "Morocco" }, { "countrycode": "MC", "countryname": "Monaco" }, { "countrycode": "MD", "countryname": "Moldova, Republic of" }, { "countrycode": "ME", "countryname": "Montenegro" }, { "countrycode": "MF", "countryname": "Saint Martin (French part)" }, { "countrycode": "MG", "countryname": "Madagascar" }, { "countrycode": "MH", "countryname": "Marshall Islands" }, { "countrycode": "MK", "countryname": "Macedonia, the former Yugoslav Republic of" }, { "countrycode": "ML", "countryname": "Mali" }, { "countrycode": "MM", "countryname": "Myanmar" }, { "countrycode": "MN", "countryname": "Mongolia" }, { "countrycode": "MO", "countryname": "Macao" }, { "countrycode": "MP", "countryname": "Northern Mariana Islands" }, { "countrycode": "MQ", "countryname": "Martinique" }, { "countrycode": "MR", "countryname": "Mauritania" }, { "countrycode": "MS", "countryname": "Montserrat" }, { "countrycode": "MT", "countryname": "Malta" }, { "countrycode": "MU", "countryname": "Mauritius" }, { "countrycode": "MV", "countryname": "Maldives" }, { "countrycode": "MW", "countryname": "Malawi" }, { "countrycode": "MX", "countryname": "Mexico" }, { "countrycode": "MY", "countryname": "Malaysia" }, { "countrycode": "MZ", "countryname": "Mozambique" }, { "countrycode": "NA", "countryname": "Namibia" }, { "countrycode": "NC", "countryname": "New Caledonia" }, { "countrycode": "NE", "countryname": "Niger" }, { "countrycode": "NF", "countryname": "Norfolk Island" }, { "countrycode": "NG", "countryname": "Nigeria" }, { "countrycode": "NI", "countryname": "Nicaragua" }, { "countrycode": "NL", "countryname": "Netherlands" }, { "countrycode": "NO", "countryname": "Norway" }, { "countrycode": "NP", "countryname": "Nepal" }, { "countrycode": "NR", "countryname": "Nauru" }, { "countrycode": "NU", "countryname": "Niue" }, { "countrycode": "NZ", "countryname": "New Zealand" }, { "countrycode": "OM", "countryname": "Oman" }, { "countrycode": "PA", "countryname": "Panama" }, { "countrycode": "PE", "countryname": "Peru" }, { "countrycode": "PF", "countryname": "French Polynesia" }, { "countrycode": "PG", "countryname": "Papua New Guinea" }, { "countrycode": "PH", "countryname": "Philippines" }, { "countrycode": "PK", "countryname": "Pakistan" }, { "countrycode": "PL", "countryname": "Poland" }, { "countrycode": "PM", "countryname": "Saint Pierre and Miquelon" }, { "countrycode": "PN", "countryname": "Pitcairn" }, { "countrycode": "PR", "countryname": "Puerto Rico" }, { "countrycode": "PS", "countryname": "Palestinian Territory, Occupied" }, { "countrycode": "PT", "countryname": "Portugal" }, { "countrycode": "PW", "countryname": "Palau" }, { "countrycode": "PY", "countryname": "Paraguay" }, { "countrycode": "QA", "countryname": "Qatar" }, { "countrycode": "RE", "countryname": "Reunion" }, { "countrycode": "RO", "countryname": "Romania" }, { "countrycode": "RS", "countryname": "Serbia" }, { "countrycode": "RU", "countryname": "Russian Federation" }, { "countrycode": "RW", "countryname": "Rwanda" }, { "countrycode": "SA", "countryname": "Saudi Arabia" }, { "countrycode": "SB", "countryname": "Solomon Islands" }, { "countrycode": "SC", "countryname": "Seychelles" }, { "countrycode": "SD", "countryname": "Sudan" }, { "countrycode": "SE", "countryname": "Sweden" }, { "countrycode": "SG", "countryname": "Singapore" }, { "countrycode": "SH", "countryname": "Saint Helena, Ascension and Tristan da Cunha" }, { "countrycode": "SI", "countryname": "Slovenia" }, { "countrycode": "SJ", "countryname": "Svalbard and Jan Mayen" }, { "countrycode": "SK", "countryname": "Slovakia" }, { "countrycode": "SL", "countryname": "Sierra Leone" }, { "countrycode": "SM", "countryname": "San Marino" }, { "countrycode": "SN", "countryname": "Senegal" }, { "countrycode": "SO", "countryname": "Somalia" }, { "countrycode": "SR", "countryname": "Suriname" }, { "countrycode": "SS", "countryname": "South Sudan" }, { "countrycode": "ST", "countryname": "Sao Tome and Principe" }, { "countrycode": "SV", "countryname": "El Salvador" }, { "countrycode": "SX", "countryname": "Sint Maarten (Dutch part)" }, { "countrycode": "SY", "countryname": "Syrian Arab Republic" }, { "countrycode": "SZ", "countryname": "Swaziland" }, { "countrycode": "TC", "countryname": "Turks and Caicos Islands" }, { "countrycode": "TD", "countryname": "Chad" }, { "countrycode": "TF", "countryname": "French Southern Territories" }, { "countrycode": "TG", "countryname": "Togo" }, { "countrycode": "TH", "countryname": "Thailand" }, { "countrycode": "TJ", "countryname": "Tajikistan" }, { "countrycode": "TK", "countryname": "Tokelau" }, { "countrycode": "TL", "countryname": "Timor-Leste" }, { "countrycode": "TM", "countryname": "Turkmenistan" }, { "countrycode": "TN", "countryname": "Tunisia" }, { "countrycode": "TO", "countryname": "Tonga" }, { "countrycode": "TR", "countryname": "Turkey" }, { "countrycode": "TT", "countryname": "Trinidad and Tobago" }, { "countrycode": "TV", "countryname": "Tuvalu" }, { "countrycode": "TW", "countryname": "Taiwan, Province of China" }, { "countrycode": "TZ", "countryname": "Tanzania, United Republic of" }, { "countrycode": "UA", "countryname": "Ukraine" }, { "countrycode": "UG", "countryname": "Uganda" }, { "countrycode": "UM", "countryname": "United States Minor Outlying Islands" }, { "countrycode": "US", "countryname": "United States" }, { "countrycode": "UY", "countryname": "Uruguay" }, { "countrycode": "UZ", "countryname": "Uzbekistan" }, { "countrycode": "VA", "countryname": "Holy See (Vatican City State)" }, { "countrycode": "VC", "countryname": "Saint Vincent and the Grenadines" }, { "countrycode": "VE", "countryname": "Venezuela, Bolivarian Republic of" }, { "countrycode": "VG", "countryname": "Virgin Islands, British" }, { "countrycode": "VI", "countryname": "Virgin Islands, U.S." }, { "countrycode": "VN", "countryname": "Viet Nam" }, { "countrycode": "VU", "countryname": "Vanuatu" }, { "countrycode": "WF", "countryname": "Wallis and Futuna" }, { "countrycode": "WS", "countryname": "Samoa" }, { "countrycode": "YE", "countryname": "Yemen" }, { "countrycode": "YT", "countryname": "Mayotte" }, { "countrycode": "ZA", "countryname": "South Africa" }, { "countrycode": "ZM", "countryname": "Zambia" }, { "countrycode": "ZW", "countryname": "Zimbabwe" }],
            clientFromAccts: [],
            selectClientModalState: false,
            genericModalMsg: ''
        }
    }
    
   componentDidMount() {
        //Get the account numbers for the selected client in parallel 

        let vendorid = this.props.wireInstruction ? this.props.wireInstruction.id : '';
        let orgid = this.props.selectedClient ? this.props.selectedClient.orgId: '';
        
        if(orgid === ''){
            this.setState({selectClientModalState: true, genericModalMsg: NoClientFoundSetupBill, isloading: false});
        }else{

            this.fetchFromAccountsForClient();
            if(this.props.mode && this.props.mode === 'VIEW'){
                this.fetchPayTermAndInstructions(vendorid, orgid);
            }else if(this.props.mode && this.props.mode === 'UPDATE'){
                this.fetchPayTermAndInstructions(vendorid, orgid);
            }else{
                //fetch vendorlist and show in dropdown 
                this.fetchPayTerms(orgid);
                this.setState({isloading: false}, () => {
                    wireInstructionFormAnimation();
                });
            }
        }
    }


    fetchPayTermAndInstructions(vendorid, orgid){
        getPayTerms('PAYTERM', orgid).then(res => {
            this.setState({payTermsList: res}, () => {
                this.fetchWireInstruction(vendorid, orgid);
            })
        })
        .catch(err => {
            console.log(err);
            this.setState({payTermsList: []}, () => {
                this.fetchWireInstruction(vendorid, orgid);
            })
        })
    }

    fetchFromAccountsForClient(){
        if(this.props.selectedClient && this.props.selectedClient.orgId){
            getEligibleFromAccount(this.props.selectedClient.orgId).then(res => {
                this.setState({clientFromAccts: res});
            })
            .catch(err => {
                console.error(err);
                this.setState({clientFromAccts: []});
            })
        }
    }


    fetchWireInstruction(vendorId, orgid){
        getWireInstructions(vendorId, orgid).then(res => {
            this.setState({wireDetails: res, isloading: false}, () => {
                this.prepopulateData();
                wireInstructionFormAnimation();
            });
        })
       .catch(err => {
           this.setState({isloading: false}, () => {
            wireInstructionFormAnimation();
           });
           message.error('Unable to fetch wires information');
           console.log("Error occured while fetching wire instruction");
       })
    }


    fetchPayTerms(orgid){
        getPayTerms('PAYTERM', orgid).then(res => {
            this.setState({payTermsList: res})
        })
        .catch(err => {
            console.log(err);
            this.setState({payTermsList: []});
            message.error('Unable to fetch payment term options');
        })
    }

    componentWillUnmount() {
        if (validateABACancellationToken !== null && validateABACancellationToken !== undefined) {
            validateABACancellationToken.cancel("Cancelling validate ABA call on unmount to prevent memory leak.");
        }

        this.props.ViewWireInstructions(null, null);
    }
    backFromVendors() {
        if (this.props.history) {
            this.props.history.push(`/vendors/${this.props.selectedClient && this.props.selectedClient.orgId ? this.props.selectedClient.orgId : ''}`);
        }
    }

    getVendorType(value){
       if(this.state.typesOfVendors && Array.isArray(this.state.typesOfVendors) && this.state.typesOfVendors.length > 0 && value){
            for(let i=0; i< this.state.typesOfVendors.length; i++){
                if(this.state.typesOfVendors[i].value === value){
                    return (this.state.typesOfVendors[i].name ? this.state.typesOfVendors[i].name : "");
                }
            }
       }else{
           return "";
       }
    }

    getPartyType(value){
        if(this.state.typesOfParties && Array.isArray(this.state.typesOfParties) && this.state.typesOfParties.length > 0){
             for(let i=0; i< this.state.typesOfParties.length; i++){
                 if(this.state.typesOfParties[i].value === value){
                     return (this.state.typesOfParties[i].name ? this.state.typesOfParties[i].name : "");
                 }
             }
        }else{
            return "";
        }
     }

     getPaymentTermValue(refcode){
         let paytermval = '';
         if(this.state.payTermsList && Array.isArray(this.state.payTermsList) && refcode){
            for(let i=0; i< this.state.payTermsList.length; i++){
                if(this.state.payTermsList[i].referenceId === refcode){
                    paytermval = this.state.payTermsList[i].value;
                    break;
                }
            }
         }

         return paytermval;
     }

    prepopulateData(){
        //Prepopulate data in state
        let clonedState = cloneDeep(this.state);
        if(this.state.wireDetails && Array.isArray(this.state.wireDetails) && this.state.wireDetails.length > 0 ){
            let paymentInstruction = this.state.wireDetails[0].paymentInstruction ? JSON.parse(this.state.wireDetails[0].paymentInstruction) : {};

            //vendor details
            clonedState.billInformation.vendorbasics.vendorname = this.state.wireDetails[0].name;
            clonedState.billInformation.vendorbasics.accountnumberwithvendor = this.state.wireDetails[0].accNumber;
            clonedState.billInformation.vendorbasics.vendortype = this.getVendorType(this.state.wireDetails[0].accountType);
            clonedState.billInformation.vendorbasics.vendortypevalue = this.state.wireDetails[0].accountType;

            let paytermval = this.getPaymentTermValue(this.state.wireDetails[0].paymentTermId);
            clonedState.billInformation.vendorpayterm = paytermval;
            clonedState.billInformation.vendorpaytermrefcode = this.state.wireDetails[0].paymentTermId;

            //account info
            clonedState.billInformation.paymentinfo.accountNumber = paymentInstruction.BankAcctFromAcctId;
            clonedState.billInformation.paymentinfo.isThirdParty = paymentInstruction.IsThirdParty; 
            clonedState.billInformation.paymentinfo.partydisplayvalue = this.getPartyType(paymentInstruction.IsThirdParty);
            clonedState.billInformation.paymentinfo.routingNumber = paymentInstruction.BeneficiaryBankRoutingId;
            clonedState.billInformation.paymentinfo.bankName = paymentInstruction.BeneficiaryBankName;
            clonedState.billInformation.paymentinfo.country = paymentInstruction.DestinationCountry;

            //update the cloned 

            clonedState.billInformation.paymentinfo.beneficiaryDetailsAccountNumber = paymentInstruction.BeneficiaryAcctId;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsVendorname = paymentInstruction.BeneficiaryName;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline1 = paymentInstruction.BeneficiaryNameAddrLine1;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline2 = paymentInstruction.BeneficiaryNameAddrLine2;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline3 = paymentInstruction.BeneficiaryNameAddrLine3;

            //Further credit 1

            clonedState.billInformation.paymentinfo.furtherCreditAccountNumber = paymentInstruction.FurtherCredit1_AccountNumber;
            clonedState.billInformation.paymentinfo.furtherCreditName = paymentInstruction.FurtherCredit1_NameLine1;
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine1 =  paymentInstruction.FurtherCredit1_NameLine2;
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine2 =  paymentInstruction.FurtherCredit1_NameLine3;
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine3 =  paymentInstruction.FurtherCredit1_NameLine4;

            //Further credit 2

            clonedState.billInformation.paymentinfo.furtherCredit2AccountNumber = paymentInstruction.FurtherCredit2_AccountNumber;
            clonedState.billInformation.paymentinfo.furtherCredit2Name = paymentInstruction.FurtherCredit2_NameLine1;
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine1 = paymentInstruction.FurtherCredit2_NameLine2;
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine2 = paymentInstruction.FurtherCredit2_NameLine3;
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine3 = paymentInstruction.FurtherCredit2_NameLine4;

            //detail lines
            clonedState.billInformation.paymentinfo.line1 = paymentInstruction.WireDisbursementDetail1;
            clonedState.billInformation.paymentinfo.line2 = paymentInstruction.WireDisbursementDetail2;
            clonedState.billInformation.paymentinfo.line3 = paymentInstruction.WireDisbursementDetail3;
            clonedState.billInformation.paymentinfo.line4 = paymentInstruction.WireDisbursementDetail4;


            clonedState.isloading = false;
            this.setState({...clonedState});
        }

    }

    handleVendorNameChange(event) {
        //const alphanumericFormat = /^[0-9a-zA-Z ]+$/;
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.vendorbasics.vendorname = event.target.value;
        this.setState(clonedState);
    }

    handleVendorNameOnBlur(event) {
        let clonedState = Object.assign({}, this.state);
        if(clonedState.messages){
            clonedState.messages.vendorNameErr = '';
        }
        if(clonedState.billInformation.vendorbasics.vendorname === ''){
            clonedState.messages.vendorNameErr = 'Vendor name is required.'
        }else{
            let isVendorExist = isVendorNameExist(clonedState.billInformation.vendorbasics.vendorname, this.props.clientVendorsList);
            if(isVendorExist && this.props.mode !== 'UPDATE'){
                clonedState.messages.vendorNameErr = 'Vendor name already exist.'
            }
        }

        this.setState(clonedState);
    }



    toggle = tab => {
        var currentTabValid = true;
        var errorMsg = "Please fill the required fields before going to other tab.";
        var messages = this.state.messages;
        if (this.state.activeTab === '1') {
            if (this.state.isLargeVendor) {
                if (this.state.validationBillInformation.vendorbasics.vendorname) {
                    currentTabValid = true;
                } else
                    currentTabValid = false;
            } else if (!this.state.isLargeVendor) {
                if (this.state.validationBillInformation.vendorbasics.vendorname && this.state.validationBillInformation.vendorbasics.vendortype && this.state.validationBillInformation.vendorbasics.primarycontactemail) {
                    currentTabValid = true;
                }
                else
                    currentTabValid = false;
            }

        } else if (this.state.activeTab === '2') {
            if (this.state.validationBillInformation.vendoraddress.country) {
                currentTabValid = true;
            } else
                currentTabValid = false;
        } else if (this.state.activeTab === '3') {
            if (this.state.validationBillInformation.vendorbanklocation) {
                currentTabValid = true;
            } else
                currentTabValid = false;
        } else if (this.state.activeTab === '5') {
            //errorMsg = "Please fill valid values for 'Payment notification email', 'Phone' and 'Fax' fields before going to other tab.";
            if (this.state.billInformation.vendorpaymenttype === "ACH") {
                if (this.state.validationBillInformation.paymentinfo.routingNumber) {
                    currentTabValid = true;
                }
            } else if (this.state.billInformation.vendorpaymenttype === "WIRE") {
                if (this.state.validationBillInformation.paymentinfo.routingNumber && this.state.validationBillInformation.paymentinfo.wirePurpose) {
                    currentTabValid = true;
                }
            } else if (this.state.validationBillInformation.paymentinfo.paymentnotificationemail && this.state.validationBillInformation.paymentinfo.phone && this.state.validationBillInformation.paymentinfo.fax) {
                errorMsg = "Please fill valid values for 'Payment notification email', 'Phone' and 'Fax' fields before going to other tab.";
                currentTabValid = true;
            } else {
                errorMsg = "Please fill valid values for 'Payment notification email', 'Phone' and 'Fax' fields before going to other tab.";
                currentTabValid = false;
            }

        }
        var errormsgIndex = messages.findIndex(item => item.text === errorMsg);
        if (currentTabValid && errormsgIndex > -1) {
            messages.splice(errormsgIndex, 1);
        } else if (!currentTabValid && errormsgIndex === -1) {
            messages.push({
                type: MessageType.INFO,
                text: errorMsg,
                class: MessageClass.ERROR
            })
        }
        if (/*currentTabValid && */this.state.activeTab !== tab)
            this.setState({ activeTab: tab, messages: messages });
        this.setState({ messages: messages });
    }

    typesOfVendorChange(vendortype) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.vendorbasics.vendortype = vendortype.name;
        clonedState.billInformation.vendorbasics.vendortypevalue = vendortype.value;
        this.setState(clonedState);

    }

    typesOfPartyChange(partytype) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.paymentinfo.isThirdParty = partytype.value;
        clonedState.billInformation.paymentinfo.partydisplayvalue = this.getPartyType(partytype.value)
        this.setState(clonedState);
    }
    
    typesOfVendorToggle() {
        if (this.state.isTypesOfVendorOpen) {
            var evt = {
                target: {
                    name: "type"
                }
            };
            this.handleOnBlur(evt);
        }
        this.setState(prevState => ({
            isTypesOfVendorOpen: !prevState.isTypesOfVendorOpen
        }))
    }

    typesOfPartyToggle() {
        this.setState(prevState => ({
            isTypesOfPartyOpen: !prevState.isTypesOfPartyOpen
        }))
    }

    fromAcctToggle() {
        this.setState(prevState => ({
            isFromAcctOpen: !prevState.isFromAcctOpen
        }))
    }

    payTermToggle() {
        this.setState(prevState => ({
            isPayTermOpen: !prevState.isPayTermOpen
        }))
    }

    handleFromAcctChange(fromaccount){
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.paymentinfo.accountNumber = fromaccount.accountNo;
        this.setState(clonedState);
    }

    handlePayTermChange(payterm){
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.vendorpayterm = payterm.value;
        clonedState.billInformation.vendorpaytermrefcode = payterm.referenceId;
        clonedState.billInformation.paymentinfo.accountNumber = '';
        this.setState(clonedState);
    }

    toggleAutoPaySetup() {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.autopaysetup = !clonedState.billInformation.autopaysetup;
        this.setState(clonedState);
    }
    vendorToggle() {
        this.setState(prevState => ({
            isVendorOpen: !prevState.isVendorOpen
        }))
    }
    vendorChange(vendor) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.additionalInformation.vendor = vendor;
        this.setState(clonedState);
    }
    combinePaymentsToggle() {
        this.setState(prevState => ({
            isCombinePaymentsOpen: !prevState.isCombinePaymentsOpen
        }))
    }

    combinePaymentsChange(combinePayments) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.additionalInformation.combinepayments = combinePayments;
        this.setState(clonedState);
    }

    accountOwnershipToggle() {
        this.setState(prevState => ({
            isAccountOwnershipOpen: !prevState.isAccountOwnershipOpen
        }))
    }

    accountOwnershipChange(value) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.paymentinfo.accountOwnership = value;
        this.setState(clonedState);
    }

    addressCountryToggle(evt) {
        if (this.state.isAddressCountryOpen) {
            var evt = {
                target: {
                    name: "country"
                }
            };
            this.handleOnBlur(evt);
        }
        this.setState(prevState => ({
            isAddressCountryOpen: !prevState.isAddressCountryOpen
        }))
    }

    addressCountryChange(value) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.vendoraddress.country = value;
        this.setState(clonedState);
    }

    stateProvinceToggle() {
        this.setState(prevState => ({
            isStateProvinceOpen: !prevState.isStateProvinceOpen
        }))
    }

    stateProvinceChange(value) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.vendoraddress.stateprovince = value;
        this.setState(clonedState);
    }

    handleNewStandingInstructionChange(evt) {
        let clonedState = Object.assign({}, this.state);
        clonedState.billInformation.paymentinfo.newStandingInstruction = !clonedState.billInformation.paymentinfo.newStandingInstruction;
        this.setState(clonedState);
    }

    getBankName(evt) {
        if (evt.target.value !== undefined
            && evt.target.value !== "") {
            let inputABA = evt.target.value;
            this.setState({ isLoading: true }, () => {
                validateABA(inputABA, this.authToken, this.contextjson, this.profilejson)
                    .then(data => {
                        if (data.ABANumbers !== null
                            && data.ABANumbers !== undefined
                            && Array.isArray(data.ABANumbers)
                            && data.ABANumbers.length > 0) {
                            let bankname = "";
                            for (let aba of data.ABANumbers) {
                                if (aba.BankCode !== null && aba.BankCode !== undefined && aba.BankCode === inputABA) {
                                    if (aba.BankName !== null && aba.BankName !== undefined) {
                                        bankname = aba.BankName;
                                        let clonedState = Object.assign({}, this.state);
                                        clonedState.billInformation.paymentinfo.bankName = aba.BankName;
                                        clonedState.validationBillInformation.paymentinfo.routingNumber = true;
                                        clonedState.messages.routingNumErr = '';
                                        this.setState(clonedState);
                                    }
                                    break;
                                }
                            }

                            //check if we did not receive any bank name
                            if (bankname === "") {
                                let clonedState = Object.assign({}, this.state);
                                clonedState.messages.routingNumErr = "Please provide valid ABA Routing number";
                                clonedState.billInformation.paymentinfo.bankName = "";
                                this.setState(clonedState);
                            }
                        } else {
                            let clonedState = Object.assign({}, this.state);
                            clonedState.messages.routingNumErr = "Please provide valid ABA Routing number";
                            clonedState.billInformation.paymentinfo.bankName = "";
                            this.setState(clonedState);
                        }
                    })
                    .catch(error => {
                        //Do nothing
                        let clonedState = Object.assign({}, this.state);
                        clonedState.messages.routingNumErr = "Please provide valid ABA Routing number";
                        clonedState.billInformation.paymentinfo.bankName = "";
                        this.setState(clonedState);
                    });
            });
        } else{
            let clonedState = Object.assign({}, this.state);
            clonedState.messages.routingNumErr = "Routing number is required.";
            clonedState.billInformation.paymentinfo.bankName = "";
            this.setState(clonedState);
        }
    }
    disableNextBtn(tab) {
        var returnValue = false;
        if (tab === '2') {
            if (this.state.validationBillInformation.vendorbasics.vendorname && this.state.validationBillInformation.vendorbasics.vendortype)
                returnValue = false
            else
                returnValue = true
        }
        return returnValue;
    }
    isSaveDisabled() {
        var myJSON = JSON.stringify(this.state.validationBillInformation);
        var pos = myJSON.search(":false");
        if (pos > -1) {
            return true;
        }
        return false;

    }

    save() {

        if (this.state.billInformation && this.state.billInformation.vendorpaymenttype) {
            switch (this.state.billInformation.vendorpaymenttype) {
                case 'CHECK': {
                    let reqBody = generatePaymentInstructionRequest(this.state.billInformation, 'CHECK', this.props.mode, this.props.selectedClient, this.props.wireInstruction);
                    break;
                }
                case 'ACH': {
                    let reqBody = generatePaymentInstructionRequest(this.state.billInformation, 'ACH', this.props.mode, this.props.selectedClient, this.props.wireInstruction);
                    break;
                }
                case 'WIRE': {
                    let reqBody = generatePaymentInstructionRequest(this.state.billInformation, 'WIRE', this.props.mode, this.props.selectedClient, this.props.wireInstruction);
                    CreateVendorPaymentInstructionForWireService(reqBody, this.authToken, this.contextjson)
                        .then(data => {
                            if (data && data.data.error_code && data.data.error_code === '000000') {
                                message.info('Wire instruction created.');
                                 if(this.props.history){
                                     this.props.history.push(`/vendors/${this.props.selectedClient.orgId}`);
                                 }
                            }else{
                                message.error("We are unable to create wire instruction");
                                console.error(data);
                            }
                        })
                        .catch(error => {
                            message.error('Unable to create wire instruction');
                            console.error(error);
                        })
                        break;
                }
                case 'INVITE': {
                    let reqBody = generatePaymentInstructionRequest(this.state.billInformation, 'INVITE');
                    break;
                }

                default: {
                    break;
                }
            }
            //Call api here...
        }


    }
    clearData() {
        var billInformation = {
            vendorbasics: {
                vendorname: "",
                vendortype: "",
                vendortypevalue: "",
                primarycontactemail: "",
                accountnumberwithvendor: ""
            },
            vendoraddress: {
                country: "",
                addressline1: "",
                addressline2: "",
                addressline3: "",
                addressline4: "",
                city: "",
                stateprovince: "",
                zippostalcode: "",
            },
            vendorbanklocation: "",
            vendorpaymenttype: "WIRE",
            vendorpayterm: '',
            vendorpaytermrefcode: '',
            autopaysetup: false,
            paymentinfo: {
                paytoname: "",
                paymentnotificationemail: "",
                phone: "",
                fax: "",
                accountOwnership: "",
                accountNickname: "",
                bankName: "",
                accountNumber: "",
                routingNumber: "",
                wirePurpose: "",
                line1: "",
                line2: "",
                line3: "",
                line4: "",
                newStandingInstruction: false,
                standingInstructionNickname: "",
                furtherCreditAccountNumber: "",
                furtherCreditName: "",
                furtherCreditAddressLine1: "",
                furtherCreditAddressLine2: "",
                furtherCreditAddressLine3: "",
                country: 'US',
                isThirdParty: false,
                partydisplayvalue : ''
            },
            contacts: {
                firstname: "",
                lastname: ""
            },
            vendordescription: "",
            additionalInformation: {
                taxid: "",
                vendor: "",
                vendorsince: "",
                leadtimedays: "",
                combinepayments: "",
                paymentterms: "",
                companyname: ""

            }
        }
        var validationBillInformation = {
            vendorbasics: {
                vendorname: false,
                vendortype: false,
                primarycontactemail: true,
            },
            vendoraddress: {
                country: false
            },
            vendorbanklocation: false,
            paymentinfo: {
                paymentnotificationemail: true,
                phone: true,
                fax: true,
                routingNumber: false,
                wirePurpose: false,
            },
        };

        this.setState({ billInformation: billInformation, validationBillInformation: validationBillInformation });
    }
    cancel() {
        this.clearData();
        var messages = {};
        this.setState({
            toggleVendorList: true, messages: messages
        })
    }
    checkPhoneNoFormat(evt) {
        const phoneNoFormat = /^[\+]?[0-9]{0,2}[0-9]{0,1}[\s.-]?[(]?[0-9]{3,4}[)]?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;
        var errorMsg = "";
        if (evt.target.name === "phone" && (evt.target.value === "" || !phoneNoFormat.test(evt.target.value))) {
            errorMsg = "Phone No is not valid";
        } else if (evt.target.name === "fax" && (evt.target.value === "" || !phoneNoFormat.test(evt.target.value))) {
            errorMsg = "Fax No is not valid";
        }
        this.setState({ errorMsg: errorMsg });
    }
    checkEmailFormat(evt) {
        const emailFormat = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        var errorMsg = "";
        if (evt.target.name === "paymentnotificationemail" && (evt.target.value === "" || !emailFormat.test(evt.target.value))) {
            errorMsg = "Payment notification email address is not valid";
        }
        else if (evt.target.name === "primarycontactemail" && (evt.target.value === "" || !emailFormat.test(evt.target.value))) {
            errorMsg = "Primary contact email address is not valid";
        }
        this.setState({ errorMsg: errorMsg });
    }
    handleOnBlur(evt) {
        let clonedState = Object.assign({}, this.state);
        //const emailFormat = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        //const phoneNoFormat = /^[\+]?[0-9]{0,2}[0-9]{0,1}[\s.-]?[(]?[0-9]{3,4}[)]?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;
        var errorMsg = "";

       if (evt.target.name === "type") {
            errorMsg = 'Vendor Type is required.';
            clonedState.messages.vendorTypeErr = '';
            if (this.state.billInformation.vendorbasics.vendortype === "") {
                clonedState.messages.vendorTypeErr = errorMsg;
            }
        }  else if (evt.target.name === "paymentinfoCountry") {
            errorMsg = 'Country is required.';
            clonedState.messages.countryErr = '';
            if (clonedState.billInformation.paymentinfo.country === "") {
                clonedState.messages.countryErr = errorMsg
            }
        } 
        this.setState(clonedState);
    }

    handleFormChanges(evt) {
        const amountFormat = /^[0-9]+(\.)?([0-9]{1,2})?$/;
        const alphanumericFormat = /^[0-9a-zA-Z ]+$/;
        const basicAlphaNumeric = /^[a-zA-Z0-9 -]+$/;
        const emailFormat = /^[a-zA-Z0-9 @._-]+$/;
        const zipFormat = /^[0-9 -]*$/;
        const phoneNoFormat = /^[0-9 +().-\s]*$/;
        const numberFormat = /^[0-9]*$/;

        let clonedState = Object.assign({}, this.state);

        if (evt.target.name === "vendorname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendorbasics.vendorname = evt.target.value;
        }
        else if (evt.target.name === "primarycontactemail" && evt.target.value.length <= 50 && (evt.target.value === "" || emailFormat.test(evt.target.value))) {
            clonedState.billInformation.vendorbasics.primarycontactemail = evt.target.value;
        }
        else if (evt.target.name === "accountnumberwithvendor" && evt.target.value.length <= 50 && (evt.target.value === "" || basicAlphaNumeric.test(evt.target.value))) {
            clonedState.billInformation.vendorbasics.accountnumberwithvendor = evt.target.value;
        }
        else if (evt.target.name === "vendorZipcode" && evt.target.value.length <= 10 && (evt.target.value === "" || zipFormat.test(evt.target.value))) {
            clonedState.billInformation.vendorbasics.vendorZipcode = evt.target.value;
        }
        else if (evt.target.name === "country" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.country = evt.target.value;
        }
        else if (evt.target.name === "addressline1" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.addressline1 = evt.target.value;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline1 = evt.target.value;
        }
        else if (evt.target.name === "addressline2" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.addressline2 = evt.target.value;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline2 = evt.target.value;
        }
        else if (evt.target.name === "addressline3" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.addressline3 = evt.target.value;
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline3 = evt.target.value;
        }
        else if (evt.target.name === "addressline4" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.addressline4 = evt.target.value;
        }
        else if (evt.target.name === "city" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.city = evt.target.value;
        }
        else if (evt.target.name === "stateprovince" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.stateprovince = evt.target.value;
        }
        else if (evt.target.name === "zippostalcode" && evt.target.value.length <= 10 && (evt.target.value === "" || zipFormat.test(evt.target.value))) {
            clonedState.billInformation.vendoraddress.zippostalcode = evt.target.value;
        }
        else if (evt.target.name === "vendorbanklocation" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendorbanklocation = evt.target.value;
        }
        else if (evt.target.name === "vendorpaymenttype") {
            clonedState.billInformation.vendorpaymenttype = evt.target.value;
        }
        else if (evt.target.name === "paytoname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.paytoname = evt.target.value;
        }
        else if (evt.target.name === "paymentnotificationemail" && evt.target.value.length <= 50 && (evt.target.value === "" || emailFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.paymentnotificationemail = evt.target.value;
        }
        else if (evt.target.name === "phone" && (evt.target.value === "" || phoneNoFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.phone = evt.target.value;
        }
        else if (evt.target.name === "fax" && (evt.target.value === "" || phoneNoFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.fax = evt.target.value;
        }
        else if (evt.target.name === "accountNickname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.accountNickname = evt.target.value;
        }
        else if (evt.target.name === "routingNumber" && evt.target.value.length <= 50 && (evt.target.value === "" || numberFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.routingNumber = evt.target.value;
        }
        else if (evt.target.name === "accountNumber" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.accountNumber = evt.target.value;
        }
        else if (evt.target.name === "wirePurpose" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.wirePurpose = evt.target.value;
        }
        else if (evt.target.name === "line1" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.line1 = evt.target.value;
        }
        else if (evt.target.name === "line2" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.line2 = evt.target.value;
        }
        else if (evt.target.name === "line3" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.line3 = evt.target.value;
        }
        else if (evt.target.name === "line4" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.line4 = evt.target.value;
        }
        else if (evt.target.name === "standingInstructionNickname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.standingInstructionNickname = evt.target.value;
        }
        else if (evt.target.name === "furtherCreditAccountNumber" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCreditAccountNumber = evt.target.value;
        }
        else if (evt.target.name === "furtherCreditName" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCreditName = evt.target.value;
        }
        else if (evt.target.name === "furtherCreditAddressLine1" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine1 = evt.target.value;
        }
        else if (evt.target.name === "furtherCreditAddressLine2" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine2 = evt.target.value;
        }
        else if (evt.target.name === "furtherCreditAddressLine3" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCreditAddressLine3 = evt.target.value;
        }
        else if (evt.target.name === "firstname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.contacts.firstname = evt.target.value;
        }
        else if (evt.target.name === "lastname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.contacts.lastname = evt.target.value;
        }
        else if (evt.target.name === "vendordescription" && evt.target.value.length <= 250 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.vendordescription = evt.target.value;
        }
        else if (evt.target.name === "taxid" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.taxid = evt.target.value;
        }
        else if (evt.target.name === "vendor" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.vendor = evt.target.value;
        }
        else if (evt.target.name === "vendorsince" && evt.target.value.length <= 4 && (evt.target.value === "" || numberFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.vendorsince = evt.target.value;
        }
        else if (evt.target.name === "leadtimedays" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.leadtimedays = evt.target.value;
        }
        else if (evt.target.name === "combinepayments" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.combinepayments = evt.target.value;
        }
        else if (evt.target.name === "paymentterms" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.paymentterms = evt.target.value;
        }
        else if (evt.target.name === "companyname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.additionalInformation.companyname = evt.target.value;
        }
        else if (evt.target.name === "beneficiaryDetailsVendorname" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.beneficiaryDetailsVendorname = evt.target.value;
        }
        else if (evt.target.name === "beneficiaryDetailsAccountNumber" && evt.target.value.length <= 50 && (evt.target.value === "" || basicAlphaNumeric.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAccountNumber = evt.target.value;
        }
        else if (evt.target.name === "beneficiaryDetailsAddressline1" && evt.target.value.length <= 50 && (evt.target.value === "" || basicAlphaNumeric.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline1 = evt.target.value;
        }
        else if (evt.target.name === "beneficiaryDetailsAddressline2" && evt.target.value.length <= 50 && (evt.target.value === "" || basicAlphaNumeric.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline2 = evt.target.value;
        }
        else if (evt.target.name === "beneficiaryDetailsAddressline3" && evt.target.value.length <= 50 && (evt.target.value === "" || basicAlphaNumeric.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.beneficiaryDetailsAddressline3 = evt.target.value;
        }
        else if (evt.target.name === "furtherCredit2AccountNumber" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCredit2AccountNumber = evt.target.value;
        }
        else if (evt.target.name === "furtherCredit2Name" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCredit2Name = evt.target.value;
        }
        else if (evt.target.name === "furtherCredit2AddressLine1" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine1 = evt.target.value;
        }
        else if (evt.target.name === "furtherCredit2AddressLine2" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine2 = evt.target.value;
        }
        else if (evt.target.name === "furtherCredit2AddressLine3" && evt.target.value.length <= 50 && (evt.target.value === "" || alphanumericFormat.test(evt.target.value))) {
            clonedState.billInformation.paymentinfo.furtherCredit2AddressLine3 = evt.target.value;
        }
        else if(evt.target.name === "paymentinfoCountry") {
            clonedState.billInformation.paymentinfo.country = evt.target.value;
        }
        this.setState(clonedState);
    }

    getVendorList() {
        this.setState(() => ({ isloading: true, requestFailed: false }));
        getVendorService()
            .then(data => {
                var vendorList = [];
                var vendorOptions = [];
                if (data.data !== null && data.data.response_data !== undefined && data.data.response_data !== null && Array.isArray(data.data.response_data) && (data.data.response_data.length > 0)) {
                    vendorList = data.data.response_data;
                    for (const [index, vendor] of vendorList.entries()) {
                        vendorOptions.push(vendor.nameOnCheck);
                    }
                }

                this.setState({ vendorList: vendorList, vendorOptions: vendorOptions, isloading: false });
            })
            .catch(error => {
                this.setState(() => ({ requestFailed: true, error: error.message }));
            })
    }

    getCountryStateList() {
        this.setState(() => ({ isloading: true, requestFailed: false }));
        getCountryStateService("Country", this.authToken, this.contextjson, this.profilejson)
            .then(data => {
                var countryList = [];
                //var vendorOptions = [];
                if (data.data !== null && data.data.response_data !== undefined && data.data.response_data !== null && Array.isArray(data.data.response_data) && (data.data.response_data.length > 0)) {
                    countryList = data.data.response_data;

                }

                this.setState({ countryList: countryList });
            })
            .catch(error => {
                this.setState(() => ({ requestFailed: true, error: error.message }));
            })
    }

    render() {
        return (
            this.state.requestFailed ?
                <div className="RCM_spinner">{MsgForFailedData}</div>
                : this.state.isloading ?
                    <div className="RCM_spinner">Loading Wire Instruction &nbsp;<Spinner animation="grow" size="sm" variant="info" ></Spinner></div> :
                        <SetupBillsView
                        state={this.state}
                        toggle={this.toggle}
                        cancel={this.cancel}
                        handleFormChanges={this.handleFormChanges}
                        handleOnBlur={this.handleOnBlur}
                        save={this.save}
                        typesOfVendorToggle={this.typesOfVendorToggle}
                        typesOfVendorChange={this.typesOfVendorChange}
                        toggleAutoPaySetup={this.toggleAutoPaySetup}
                        checkPhoneNoFormat={this.checkPhoneNoFormat}
                        checkEmailFormat={this.checkEmailFormat}
                        vendorToggle={this.vendorToggle}
                        vendorChange={this.vendorChange}
                        combinePaymentsToggle={this.combinePaymentsToggle}
                        combinePaymentsChange={this.combinePaymentsChange}
                        disableNextBtn={this.disableNextBtn}
                        isSaveDisabled={this.isSaveDisabled}
                        accountOwnershipToggle={this.accountOwnershipToggle}
                        accountOwnershipChange={this.accountOwnershipChange}
                        getBankName={this.getBankName}
                        handleNewStandingInstructionChange={this.handleNewStandingInstructionChange}
                        handleVendorNameChange={this.handleVendorNameChange}
                        handleVendorNameOnBlur={this.handleVendorNameOnBlur}

                        addressCountryToggle={this.addressCountryToggle}
                        addressCountryChange={this.addressCountryChange}
                        stateProvinceChange={this.stateProvinceChange}
                        stateProvinceToggle={this.stateProvinceToggle}
                        mode={this.props.mode}
                        selectedClient={this.props.selectedClient}
                        backFromVendors={this.backFromVendors}
                        typesOfPartyChange={this.typesOfPartyChange}
                        typesOfPartyToggle={this.typesOfPartyToggle}
                        fromAcctToggle={this.fromAcctToggle}
                        handleFromAcctChange={this.handleFromAcctChange}
                        payTermToggle = {this.payTermToggle}
                        handlePayTermChange = {this.handlePayTermChange}
                        />
        )

    }
}

const mapStateToProps = store => {
    return {
        wireInstruction: store.vendors.wireInstruction,
        selectedClient: store.dashboard.selectedClient,
        mode: store.vendors.mode,
        clientVendorsList: store.vendors.clientVendorsList
    };
};

const mapDispatchToProps = {
    ViewWireInstructions
}

export default connect(mapStateToProps, mapDispatchToProps)(SetupBills);
